import { getCookie } from "../../utils/cookie-service";
import { UPDATE_USER } from "../mutations";
import { ACCESS } from "../mutations";

let authUser = getCookie("authUser");

const initialState = {
  currentUser: authUser,
  isAuthenticated: authUser !== undefined ? true : false,
  accessSettings: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        currentUser: action.payload,
        isAuthenticated: action.payload !== null,
      };
    case ACCESS:
      return {
        ...state,
        accessSettings: action.payload.settings || null,
      };
    default:
      return state;
  }
}
